class AsyncNamedQueue {
    constructor(maxConcurrent) {
        this.queues = new Map(); // Separate queues for different names
        this.activeCounts = new Map();
        this.maxConcurrent = maxConcurrent;
    }

    async run(name, fn) {
        if (!this.queues.has(name)) {
            this.queues.set(name, []);
            this.activeCounts.set(name, 0);
        }

        return new Promise((resolve, reject) => {
            this.queues.get(name).push({ fn, resolve, reject });
            this.processQueue(name);
        });
    }

    async processQueue(name) {
        if (!this.queues.has(name)) return;
        if (
            this.activeCounts.get(name) >= this.maxConcurrent ||
            this.queues.get(name).length === 0
        ) {
            return;
        }

        const { fn, resolve, reject } = this.queues.get(name).shift();
        this.activeCounts.set(name, this.activeCounts.get(name) + 1);

        try {
            const result = await fn();
            resolve(result);
        } catch (error) {
            reject(error);
        } finally {
            this.activeCounts.set(name, this.activeCounts.get(name) - 1);
            this.processQueue(name); // Process the next task for this name
        }
    }
}

// Allow max 3 concurrent calls per name
const appConfigAsyncNamedQueue = new AsyncNamedQueue(3);

export { appConfigAsyncNamedQueue };
